var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5608 19.5608C11.842 19.2795 12 18.8981 12 18.5003C12 18.1026 11.842 17.7211 11.5608 17.4398L4.13582 10.0148L11.5608 2.58982C11.8341 2.30692 11.9853 1.92801 11.9818 1.53472C11.9784 1.14142 11.8207 0.765203 11.5425 0.487091C11.2644 0.208979 10.8882 0.0512275 10.4949 0.0478095C10.1016 0.0443915 9.72273 0.195583 9.43982 0.46882L0.954319 8.95432C0.673113 9.23561 0.51514 9.61707 0.515139 10.0148C0.515139 10.4126 0.673113 10.794 0.954319 11.0753L9.43982 19.5608C9.72111 19.842 10.1026 20 10.5003 20C10.8981 20 11.2795 19.842 11.5608 19.5608Z",
    fill: "#033272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.5851c14af0c82e5291ba6891095804f0.svg";
export { ForwardRef as ReactComponent };